import { ArchiveMutation } from "../../../hooks/useArchiveState";
import { VisitNoteTemplateControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author [Rajkumar Rathod]
 */
export const useArchiveVisitNoteTemplate = () =>
  useMutationWithLoading(async (param: ArchiveMutation) =>
    new VisitNoteTemplateControllerApi(
      getConfigObject()
    ).updateVisitNoteTemplateArchiveStatus(
      param.id,
      param.status,
      param.xTENANTID //xTENANTID
    )
  );
